





















































































import Vue from 'vue';
import { OutlinedTextInput } from '@/components/ds';
import ProuniFileUpload from '@/components/forms/prouni/ProuniFileUpload.vue';
import {
  formatCurrency,
  formatNumberToCurrency,
  parseCurrencyToNumber,
} from '@/helpers/formatters';
import {
  ProuniDocument,
  ProuniDocumentType,
  ProuniFamilyMember,
} from '@/store/modules/prouni/types';

export default Vue.extend({
  name: 'ProuniFamilyMemberCard',
  components: { OutlinedTextInput, ProuniFileUpload },
  props: {
    index: {
      type: Number,
      required: true,
    },
    member: {
      type: Object as () => ProuniFamilyMember,
      default: () => ({}),
    },
    documents: {
      type: Array as () => ProuniDocument[],
      default: () => [],
    },
  },
  data() {
    const member: ProuniFamilyMember = this.member || {};
    const memberDocs = (this.documents || []).filter(d => d.familyMemberId === member.id);
    return {
      familyMemberId: member.id || null,
      form: {
        name: member.name || '',
        income: member.income != null ? formatNumberToCurrency(Number(member.income)) : '',
      },
      masks: { currency: formatCurrency },
      isSaving: false,
      uploaded: {
        id: memberDocs.some(d => d.documentType === ProuniDocumentType.familyMemberId),
        residence: memberDocs.some(
          d => d.documentType === ProuniDocumentType.familyMemberResidenceProof,
        ),
        income1: memberDocs.some(
          d => d.documentType === ProuniDocumentType.familyMemberIncomeProofMonth1,
        ),
        income2: memberDocs.some(
          d => d.documentType === ProuniDocumentType.familyMemberIncomeProofMonth2,
        ),
        income3: memberDocs.some(
          d => d.documentType === ProuniDocumentType.familyMemberIncomeProofMonth3,
        ),
      },
      documentTypes: ProuniDocumentType,
    };
  },
  computed: {
    isValid(): boolean {
      return Boolean(
        this.form.name &&
          this.form.income &&
          this.familyMemberId &&
          this.uploaded.id &&
          this.uploaded.residence &&
          this.uploaded.income1 &&
          this.uploaded.income2 &&
          this.uploaded.income3,
      );
    },
  },
  mounted() {
    // Emit the initial validity so a fully-filled member (revisited) counts as valid.
    this.emitState();
  },
  methods: {
    // Runs on every keystroke: only recompute validity/emit state. Persisting
    // is deferred to @blur (persistMember) so we never save a half-typed value.
    fieldsHandler() {
      this.emitState();
    },
    async persistMember() {
      if (this.isSaving) return;
      if (!this.form.name || !this.form.income) return;

      this.isSaving = true;
      try {
        const saved = await this.$store.dispatch('UPSERT_PROUNI_FAMILY_MEMBER', {
          id: this.familyMemberId || undefined,
          name: this.form.name,
          income: parseCurrencyToNumber(this.form.income),
        });
        if (saved && saved.id) {
          this.familyMemberId = saved.id;
          this.$emit('persisted', { index: this.index, id: saved.id });
        }
      } catch (err) {
        this.$emit('error');
      } finally {
        this.isSaving = false;
        this.emitState();
      }
    },
    setUploaded(kind: 'id' | 'residence' | 'income1' | 'income2' | 'income3', value: boolean) {
      this.uploaded[kind] = value;
      this.emitState();
    },
    emitState() {
      this.$emit('change', {
        index: this.index,
        id: this.familyMemberId,
        name: this.form.name,
        income: parseCurrencyToNumber(this.form.income),
        isValid: this.isValid,
      });
    },
    removeHandler() {
      this.$emit('remove', { index: this.index, id: this.familyMemberId });
    },
  },
});
